class EventShim {
  type: string;
  constructor(type: string) {
    this.type = `${type}`;
  }
}

const listenersMap: WeakMap<
  EventTagerShim,
  Map<string, Array<any>>
> = new WeakMap();

class EventTagerShim {
  constructor() {
    listenersMap.set(this, new Map());
  }
  addEventListener(eventName: string, listener: any) {
    if (listener == null) {
      return;
    }
    if (typeof listener !== "function") {
      throw new TypeError("'listener' should be a function or an object.");
    }

    const listeners = listenersMap.get(this);
    if (!listeners) {
      return new Error("listenersMap has not this");
    }
    let stacks = listeners.get(eventName);
    if (stacks === undefined) {
      stacks = [];
    }
    if (stacks.indexOf(listener) === -1) {
      stacks.push(listener);
    }
    listeners.set(eventName, stacks);
    return;
  }

  removeEventListener(eventName: string, listener: any): any {
    if (listener == null) {
      return;
    }

    const listeners = listenersMap.get(this);
    if (!listeners) {
      return new Error("listenersMap has not this");
    }
    let stacks = listeners.get(eventName);
    if (stacks === undefined) {
      stacks = [];
    }
    const index = stacks.indexOf(listener);
    if (index !== -1) {
      stacks.splice(index, 1);
    }
    listeners.set(eventName, stacks);
    return;
  }

  dispatchEvent(event: EventShim) {
    if (event == null || typeof event.type !== "string") {
      throw new TypeError('"event.type" should be a string.');
    }

    const listeners = listenersMap.get(this);
    if (!listeners) {
      return new Error("listenersMap has not this");
    }

    const eventName = event.type;
    let stacks = listeners.get(eventName);
    if (stacks === undefined) {
      return true;
    }

    stacks.forEach(fn => {
      fn(event);
    });
    return true;
  }
}

export { EventShim, EventTagerShim };
